import { render, staticRenderFns } from "./BatchRowItem.vue?vue&type=template&id=5ab15b63&scoped=true&"
import script from "./BatchRowItem.vue?vue&type=script&lang=js&"
export * from "./BatchRowItem.vue?vue&type=script&lang=js&"
import style0 from "./BatchRowItem.vue?vue&type=style&index=0&id=5ab15b63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab15b63",
  null
  
)

export default component.exports